const externalComponents = {
  ButestivalFrontend: () =>
    import(
      /* webpackChunkName: "BuTestivalFrontend" */ '@/js/components/Forms/TestivalForm/components/TestivalForm.vue'
    ),
}

export default {
  // Features
  TicketOverview: () =>
    import(
      /* webpackChunkName: "TicketOverview" */ '@/js/components/Account/TicketOverview/components/TicketOverview.vue'
    ),
  // Content Elements
  BuCeHintBox: () =>
    import(
      /* webpackChunkName: "BuCeHintBox" */ '@/js/components/ContentElement/Elements/BuCeHintBox.vue'
    ),
  BuCeText: () =>
    import(
      /* webpackChunkName: "BuCeText" */ '@/js/components/ContentElement/Elements/BuCeText.vue'
    ),
  BuCeVideo: () =>
    import(
      /* webpackChunkName: "BuCeVideo" */ '@/js/components/ContentElement/Elements/BuCeVideo.vue'
    ),
  DealerbookProductGroup: () =>
    import(
      /* webpackChunkName: "DealerbookProductGroups" */ '@/js/components/ContentElement/Elements/DealerbookProductGroups.vue'
    ),
  DealerbookMainNav: () =>
    import(
      /* webpackChunkName: "DealerbookMainNav" */ '@/js/components/ContentElement/Elements/DealerbookMainNav.vue'
    ),
  FallbackElement: () =>
    import(
      /* webpackChunkName: "FallbackElement" */ '@/js/components/ContentElement/Elements/FallbackElement.vue'
    ),
  BuCeSpacer: () =>
    import(
      /* webpackChunkName: "BuCeSpacer" */ '@/js/components/ContentElement/Elements/BuCeSpacer.vue'
    ),
  BuCeTable: () =>
    import(
      /* webpackChunkName: "BuCeTable" */ '@/js/components/ContentElement/Elements/BuCeTable.vue'
    ),
  BuCeImage: () =>
    import(
      /* webpackChunkName: "BuCeImage" */ '@/js/components/ContentElement/Elements/BuCeImage.vue'
    ),
  ImageElement: () =>
    import(
      /* webpackChunkName: "ImageElement" */ '@/js/components/ContentElement/Elements/ImageElement.vue'
    ),
  BuCeFilelist: () =>
    import(
      /* webpackChunkName: "BuCeFilelist" */ '@/js/components/ContentElement/Elements/BuCeFilelist.vue'
    ),
  BuCeGrids: () =>
    import(
      /* webpackChunkName: "BuCeGrids" */ '@/js/components/ContentElement/Elements/BuCeGrids.vue'
    ),
  BuCeGallery: () =>
    import(
      /* webpackChunkName: "BuCeGallery" */ '@/js/components/ContentElement/Elements/BuCeGallery.vue'
    ),
  BuCeImageTextTile: () =>
    import(
      /* webpackChunkName: "BuCeImageTextTile" */ '@/js/components/ContentElement/Elements/BuCeImageTextTile.vue'
    ),
  BuCeImageBrandTile: () =>
    import(
      /* webpackChunkName: "BuCeImageBrandTile" */ '@/js/components/ContentElement/Elements/BuCeImageBrandTile.vue'
    ),
  GridElement: () =>
    import(
      /* webpackChunkName: "GridElement" */ '@/js/components/ContentElement/Elements/GridElement.vue'
    ),
  BuCeAccordion: () =>
    import(
      /* webpackChunkName: "BuCeAccordion" */ '@/js/components/ContentElement/Elements/BuCeAccordion.vue'
    ),
  AccordionElement: () =>
    import(
      /* webpackChunkName: "AccordionElement" */ '@/js/components/ContentElement/Elements/AccordionElement.vue'
    ),
  BuCeProduct: () =>
    import(
      /* webpackChunkName: "BuCeProduct" */ '@/js/components/ContentElement/Elements/BuCeProduct.vue'
    ),
  BuCeImageHeaderTile: () =>
    import(
      /* webpackChunkName: "BuCeImageHeaderTile" */ '@/js/components/ContentElement/Elements/BuCeImageHeaderTile.vue'
    ),
  CatalogLists: () =>
    import(
      /* webpackChunkName: "CatalogLists" */ '@/js/components/ContentElement/Elements/CatalogLists.vue'
    ),
  ProductsElement: () =>
    import(
      /* webpackChunkName: "ProductsElement" */ '@/js/components/ContentElement/Elements/ProductsElement.vue'
    ),
  CatalogDetail: () =>
    import(
      /* webpackChunkName: "CatalogDetail" */ '@/js/components/ContentElement/Elements/CatalogDetail.vue'
    ),
  BackgroundElement: () =>
    import(
      /* webpackChunkName: "BackgroundElement" */ '@/js/components/ContentElement/Elements/BackgroundElement.vue'
    ),
  CheckoutStandard: () =>
    import(
      /* webpackChunkName: "CheckoutStandard" */ '@/js/components/ContentElement/Elements/CheckoutStandard.vue'
    ),
  BuCeHelpGrids: () =>
    import(
      /* webpackChunkName: "BuCeHelpGrids" */ '@/js/components/ContentElement/Elements/BuCeHelpGrids.vue'
    ),
  MessageCenter: () =>
    import(
      /* webpackChunkName: "MessageCenter" */ '@/js/components/ContentElement/Elements/MessageCenter.vue'
    ),
  CheckoutConfirm: () =>
    import(
      /* webpackChunkName: "CheckoutConfirm" */ '@/js/components/ContentElement/Elements/CheckoutConfirm.vue'
    ),
  BackorderList: () =>
    import(
      /* webpackChunkName: "BackorderList" */ '@/js/components/ContentElement/Elements/BackorderList.vue'
    ),
  OrdertrackingList: () =>
    import(
      /* webpackChunkName: "OrdertrackingList" */ '@/js/components/ContentElement/Elements/OrdertrackingList.vue'
    ),
  AccountBilling: () =>
    import(
      /* webpackChunkName: "AccountBilling" */ '@/js/components/ContentElement/Elements/AccountBilling.vue'
    ),
  UserManagementList: () =>
    import(
      /* webpackChunkName: "UserManagementList" */ '@/js/components/ContentElement/Elements/UserManagementList.vue'
    ),
  AccountDelivery: () =>
    import(
      /* webpackChunkName: "AccountDelivery" */ '@/js/components/ContentElement/Elements/AccountDelivery.vue'
    ),
  AccountDeliveryItem: () =>
    import(
      /* webpackChunkName: "AccountDeliveryItem" */ '@/js/components/ContentElement/Elements/AccountDeliveryItem.vue'
    ),
  BuwidgetsWidgets: () =>
    import(
      /* webpackChunkName: "BuwidgetsWidgets" */ '@/js/components/ContentElement/Elements/BuwidgetsWidgets.vue'
    ),
  ...externalComponents,
  CreditLimitList: () =>
    import(
      /* webpackChunkName: "CreditLimitList" */ '@/js/components/ContentElement/Elements/CreditLimitList.vue'
    ),
  CreditLimitOpenItems: () =>
    import(
      /* webpackChunkName: "CreditLimitOpenItems" */ '@/js/components/ContentElement/Elements/CreditLimitOpenItems.vue'
    ),
  BuCeLinkTiles: () =>
    import(
      /* webpackChunkName: "BuCeLinkTiles" */ '@/js/components/ContentElement/Elements/BuCeLinkTiles.vue'
    ),
  LaunchportalHeader: () =>
    import(
      /* webpackChunkName: "LaunchportalHeader" */ '@/js/components/ContentElement/Elements/LaunchportalHeader.vue'
    ),
  BuCeQuotes: () =>
    import(
      /* webpackChunkName: "BuCeQuotes" */ '@/js/components/ContentElement/Elements/BuCeQuotes.vue'
    ),
  NavigationLaunchPortal: () =>
    import(
      /* webpackChunkName: "NavigationLaunchPortal" */ '@/js/components/ContentElement/Elements/NavigationLaunchPortal.vue'
    ),
  BuCeProductHighlights: () =>
    import(
      /* webpackChunkName: "BuCeProductHighlights" */ '@/js/components/ContentElement/Elements/BuCeProductHighlights.vue'
    ),
  BuCeLevels: () =>
    import(
      /* webpackChunkName: "BuCeLevels" */ '@/js/components/ContentElement/Elements/BuCeLevels.vue'
    ),
  BuCeLaunchGallery: () =>
    import(
      /* webpackChunkName: "BuCeLaunchGallery" */ '@/js/components/ContentElement/Elements/BuCeLaunchGallery.vue'
    ),
  BuCeImageWithButton: () =>
    import(
      /* webpackChunkName: "BuCeImageWithButton" */ '@/js/components/ContentElement/Elements/BuCeImageWithButton.vue'
    ),
  BuCeImageHeaderTileGroup: () =>
    import(
      /* webpackChunkName: "BuCeImageHeaderTileGroup" */ '@/js/components/ContentElement/Elements/BuCeImageHeaderTileGroup.vue'
    ),
  ContactdataElement: () =>
    import(
      /* webpackChunkName: "ContactdataElement" */ '@/js/components/ContentElement/Elements/ContactdataElement.vue'
    ),
  ContractCheckList: () =>
    import(
      /* webpackChunkName: "ContractCheckList" */ '@/js/components/ContentElement/Elements/ContractCheckList.vue'
    ),
  MicroserviceHelper: () =>
    import(
      /* webpackChunkName: "MicroserviceHelper" */ '@/js/components/Microservices/MicroserviceHelper.vue'
    ),
}
